import theme, { zeroBorder } from '@services/theme'

const selectedTypo = {
    backgroundColor: theme.palette.leftPanel.selected,
    ['& .MuiTypography-body1']: {
        color: theme.palette.leftPanel.selectedColor
    },
    ['& .MuiIcon-root']: {
        color: theme.palette.leftPanel.selectedColor
    }
}

const typo = {
    ['& .MuiTypography-body1']: {
        fontSize: '14px',
        fontWeight: '600 !important',
        color: theme.palette.leftPanel.color
    },
    ['& .MuiIcon-root']: {
        color: theme.palette.leftPanel.color
    }
}

const baseCta = {
    ...typo,
    background: theme.palette.leftPanel.background,
    color: theme.palette.leftPanel.color,
    [`&:hover`]: {
        background: theme.palette.leftPanel.hover,
        color: theme.palette.leftPanel.hoverColor,
        ['& .MuiTypography-body1']: {
            color: theme.palette.leftPanel.hoverColor
        },
        ['& .MuiIcon-root']: {
            color: theme.palette.leftPanel.hoverColor
        }
    }
}

const baseSubCta = {
    ...typo,
    ...baseCta,
    ...zeroBorder,
    pl: 12,
    height: '36px',
    cursor: 'pointer',
    textTransform: 'none',
    color: theme.palette.leftPanel.color,
    backgroundColor: theme.palette.leftPanel.background
}

export default {
    mainCta: {
        ...baseCta
    },
    subCta: {
        ...baseSubCta,
        [`&.selected`]: {
            ...selectedTypo,
            borderLeft: `4px solid ${theme.palette.leftPanel.selectedBorder}`,
            paddingLeft: '92px'
        }
    }
}